import Email from "./Email";

type ThreadProps = {
    mails: Email[];
};

export default class Thread {
    mails: Email[];

    constructor({ mails }: ThreadProps) {
        this.mails = mails;
    }
}
